const initState = {
  MomentoRatingTrue: [],
  MomentoRatingFalse: [],
  talkingRatingTrue: [],
  talkingRatingFalse: [],
  seasonalRatingTrue: [],
  seasonalRatingFalse: [],
  chatRatingTrue: [],
  chatRatingFalse: [],
};
const ratingReducers = (state = initState, action) => {
  switch (action.type) {
    case "GET_MOMENTO_RATING_FALSE":
      return {
        ...state,
        MomentoRatingFalse: action.payload,
      };
    case "GET_MOMENTO_RATING_TRUE":
      return {
        ...state,
        MomentoRatingTrue: action.payload,
      };
    case "GET_TALKING_RATING_FALSE":
      return {
        ...state,
        talkingRatingFalse: action.payload,
      };
    case "GET_TALKING_RATING_TRUE":
      return {
        ...state,
        talkingRatingTrue: action.payload,
      };
    case "GET_SEASONAL_RATING_FALSE":
      return {
        ...state,
        seasonalRatingFalse: action.payload,
      };
    case "GET_SEASONAL_RATING_TRUE":
      return {
        ...state,
        seasonalRatingTrue: action.payload,
      };
    case "GET_CHAT_RATING_FALSE":
      return {
        ...state,
        chatRatingFalse: action.payload,
      };
    case "GET_CHAT_RATING_TRUE":
      return {
        ...state,
        chatRatingTrue: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default ratingReducers;
